<template>
  <div
    class="row m-0 p-0 mb-4 bg-white shadow-muted-super"
    style="border: 1px solid #dee2e6"
    :id="'budgetSummaryTable-' + $route.name"
  >
    <div class="w-100 py-2 text-muted small" style="border-bottom: 1px solid #dee2e6; padding-left: 13px;">
      Übersicht - Aktuelles Budget
    </div>
    <!---------------------------------
            BUDGET SUMMARY SECTION
        ---------------------------------->
    <div class="px-2 w-100" ref="budgetSummarySection">
      <table class="table table-sm table-borderless mb-0" style="table-layout: fixed;">
        <tr>
          <td class="align-middle text-muted" style="width:15%">KKE-Budget:</td>
          <td class="text-right" style="width:13%">
            <div class="bg-light m-0 p-1">
              {{ formatCurrency(KkeBudgetSummary) }}
            </div>
          </td>
          <td style="max-width:4%"></td>
          <td style="border-left: 1px solid #dee2e6;max-width:4%"></td>
          <td class="align-middle text-muted" style="width:15%">&nbsp;</td>
          <td class="text-right" style="width:13%">
            <div class="bg-light m-0 p-1">
              {{ formatCurrency(KkeBudgetAllocatedSummary) }}
            </div>
          </td>
          <td style="max-width:4%"></td>
          <td style="border-left: 1px solid #dee2e6;max-width:4%"></td>
          <td class="align-middle text-muted" style="width:15%">&nbsp;</td>
          <td class="text-right" style="width:13%">
            <div class="bg-light m-0 p-1">
              {{ formatCurrency(KkeBudgetSummary - KkeBudgetAllocatedSummary) }}
            </div>
          </td>
        </tr>
        <tr style="border-bottom: 4px double #dee2e6;">
          <td class="align-middle text-muted">PÄT-Budget:</td>
          <td class="text-right">
            <div class="bg-light m-0 p-1">
              {{ formatCurrency(PatBudgetSummary) }}
            </div>
          </td>
          <td></td>
          <td style="border-left: 1px solid #dee2e6"></td>
          <td class="align-middle">&nbsp;</td>
          <td class="text-right">
            <div class="bg-light m-0 p-1">
              {{ formatCurrency(PatBudgetAllocatedSummary) }}
            </div>
          </td>
          <td></td>
          <td style="border-left: 1px solid #dee2e6"></td>
          <td class="align-middle">&nbsp;</td>
          <td class="text-right">
            <div class="bg-light m-0 p-1">
              {{ formatCurrency(PatBudgetSummary - PatBudgetAllocatedSummary) }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="align-middle font-weight-bold text-muted" style="width:20%">Gesamtbudget:</td>
          <td class="text-right">
            <div class="bg-light m-0 p-1 font-weight-bold">
              {{ formatCurrency(KkeBudgetSummary + PatBudgetSummary) }}
            </div>
          </td>
          <td></td>
          <td style="border-left: 1px solid #dee2e6"></td>
          <td class="align-middle font-weight-bold text-muted">&nbsp;Zugewiesen:</td>
          <td class="text-right">
            <div class="bg-light m-0 p-1 font-weight-bold">
              {{ formatCurrency(KkeBudgetAllocatedSummary + PatBudgetAllocatedSummary) }}
            </div>
          </td>
          <td></td>
          <td style="border-left: 1px solid #dee2e6"></td>
          <td class="align-middle font-weight-bold text-muted">&nbsp;Freie Mittel:</td>
          <td class="text-right">
            <div class="bg-light m-0 p-1 font-weight-bold">
              {{
                formatCurrency(
                  KkeBudgetSummary - KkeBudgetAllocatedSummary + (PatBudgetSummary - PatBudgetAllocatedSummary)
                )
              }}
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import BudgetService from '@/service/BudgetService';
import SettingsStore from '@/store/Settings';
export default {
  data() {
    return {
      KkeBudgetSummary: null,
      KkeBudgetAllocatedSummary: null,
      PatBudgetSummary: null,
      PatBudgetAllocatedSummary: null,
      SettingsStore
    };
  },
  methods: {
    loadSummaryData() {
      BudgetService.getSummary()
        .then(summary => {
          this.KkeBudgetSummary = parseFloat(summary.KkeBudgetSummary);
          this.KkeBudgetAllocatedSummary = parseFloat(summary.KkeBudgetAllocatedSummary);
          this.PatBudgetSummary = parseFloat(summary.PatBudgetSummary);
          this.PatBudgetAllocatedSummary = parseFloat(summary.PatBudgetAllocatedSummary);
        })
        .catch(err => console.log(err.toString()));
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, SettingsStore.settings['Centbetraege']);
    }
  },

  activated() {
    this.loadSummaryData();
  },
  mounted() {
    const that = this;
    this.$eventBus.$on('budget:changed', function() {
      that.loadSummaryData();
    });
  }
};
</script>

<style></style>
